import { render, staticRenderFns } from "./MaxClassifyMenu.vue?vue&type=template&id=618378a8&scoped=true&"
import script from "./MaxClassifyMenu.vue?vue&type=script&lang=js&"
export * from "./MaxClassifyMenu.vue?vue&type=script&lang=js&"
import style0 from "./MaxClassifyMenu.vue?vue&type=style&index=0&id=618378a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618378a8",
  null
  
)

export default component.exports